import { Container, Title, Button } from '@/components'

import styles from './styles.module.scss'

import { ADVANTAGES } from './constants'
import Image from 'next/image'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const Advantage = () => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <section className={`fgt-section ${styles.advantage}`}>
      <Container>
        <Title Tag="h2" alignText="center">
          A <span>MAIOR</span> ACADEMIA DE AULAS AO VIVO <span>DO MUNDO</span>
        </Title>

        <p className="fgt-subtitle">
          Decole rumo aos seus objetivos, transformando sua rotina de
          treinamento e alcançando novas alturas.
        </p>

        <div className={styles.advantage__list}>
          {ADVANTAGES.map((item, index) => {
            return (
              <div className={styles.advantage__item} key={index}>
                <div className={styles.advantage__itemImage}>
                  <Image
                    src={item.iconImagePath}
                    alt={item.title}
                    width={44}
                    height={44}
                  />
                </div>
                <div className={styles.advantage__itemContent}>
                  <h3 className={styles['advantage__itemContent--title']}>
                    {item.title}
                  </h3>
                  <p>{item.subtitle}</p>
                </div>
              </div>
            )
          })}
        </div>

        <div className="fgt-section__action">
          <Button
            id="btn-section-advantage"
            variant="primary"
            className={'fgt-section__action--button'}
            onClick={() => {
              onClickItem('comparePlans', 0)
            }}
          >
            GARANTIR MEUS 7 DIAS
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default Advantage
